/* ============================================================
   Vantor — Become a Retailer form (TPC-1140).
   Vantor.contact (vantor-contact.js) checks it as the distributor
   type. This file adds what only this page does: first-error focus
   in the page's own order, the sticky panel, the busy guard, and the
   values kept across a failed POST. It never sends the form itself:
   Shopify's captcha script decides whether the native POST goes.
   ============================================================ */
(function (V) {
  var C = V.contact, TYPE = 'distributor';
  /* Shopify returns name, email, phone and body after a failed POST; these it does not */
  var KEPT = ['company', 'street', 'city', 'state', 'zip', 'installs'];
  var KEY = 'vantor-retailer-apply';
  /* a captcha challenge the visitor closes raises no event, so a busy form gives Send back after this */
  var RELEASE_MS = 20000;

  var panel = document.querySelector('[data-panel]');
  function fit() {
    var top = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-h-xl')) + 20;
    panel.classList.toggle('is-sticky', panel.offsetHeight + top + 20 <= window.innerHeight);
  }
  if (panel) {
    window.addEventListener('resize', fit);
    if (window.ResizeObserver) new ResizeObserver(fit).observe(panel);
    fit();
  }

  var kept = null;
  try { kept = JSON.parse(sessionStorage.getItem(KEY)); } catch (e) { /* a parse error or a blocked read keeps nothing */ }
  try { sessionStorage.removeItem(KEY); } catch (e) { /* a blocked removal cannot stop the form */ }

  var done = document.querySelector('[data-success]');
  if (done) done.focus();
  var form = document.getElementById('RetailerForm');
  var button = form && form.querySelector('[data-submit]');
  if (!button) return;

  var fields = C.fieldsIn(form), list = form.querySelector('[data-fields]');
  var label = button.textContent, busy = false, held = {}, release;

  function read(f) {
    if (f.controls[0].type !== 'radio') return f.controls[0].value;
    var on = f.controls.filter(function (c) { return c.checked; })[0];
    return on ? on.value : '';
  }

  function write(f, value) {
    if (f.controls[0].type === 'radio') f.controls.forEach(function (c) { c.checked = c.value === value; });
    else f.controls[0].value = value;
  }

  /* A select and a radio have no read-only state, so while busy each is held at its value. */
  function heldName(target) {
    return Object.keys(held).filter(function (name) { return fields[name].controls.indexOf(target) >= 0; })[0];
  }

  function setBusy(on) {
    busy = on;
    clearTimeout(release);
    held = {};
    Object.keys(fields).forEach(function (name) {
      var c = fields[name].controls[0];
      if (c.type === 'radio' || c.tagName === 'SELECT') { if (on) held[name] = read(fields[name]); }
      else fields[name].controls.forEach(function (x) { x.readOnly = on; });
    });
    list.inert = on;
    /* aria-disabled rather than disabled: a disabled button drops focus to the page */
    ['aria-disabled', 'aria-busy'].forEach(function (a) { if (on) button.setAttribute(a, 'true'); else button.removeAttribute(a); });
    if (on) form.setAttribute('aria-busy', 'true'); else form.removeAttribute('aria-busy');
    button.textContent = on ? button.getAttribute('data-busy-label') : label;
    if (on) release = setTimeout(function () { setBusy(false); }, RELEASE_MS);
  }

  function keep() {
    var values = {};
    KEPT.forEach(function (name) { values[name] = read(fields[name]); });
    try { sessionStorage.setItem(KEY, JSON.stringify(values)); } catch (e) { /* the POST still goes; only the restore is lost */ }
  }

  function restore() {
    if (!kept || !form.querySelector('[data-failed]')) return;
    KEPT.forEach(function (name) { if (kept[name] && !read(fields[name])) write(fields[name], kept[name]); });
  }

  function onSubmit(event) {
    /* hold() cancels the visitor's own activations while busy, so a submit event then comes from a script and goes through */
    if (event.target !== form || busy) return;
    C.tidy(fields);
    var errors = C.check(TYPE, fields);
    var first = Object.keys(fields).filter(function (name) { return errors[name]; })[0];
    C.paint(errors, fields);
    if (!first) { keep(); setBusy(true); button.focus(); return; }
    event.preventDefault();
    event.stopImmediatePropagation();
    C.focusTarget(fields[first]).focus();
    var head = document.querySelector('.site-head');
    var wrap = fields[first].wrap;
    if (head && wrap.getBoundingClientRect) {
      var bar = head.getBoundingClientRect().bottom;
      var top = wrap.getBoundingClientRect().top;
      if (top < bar) window.scrollBy(0, top - bar);
    }
  }

  /* the browser turns Enter in a field into a click on Send, so cancelling that click covers it */
  function hold(event) {
    if (!busy || event.isTrusted === false) return;
    if (button.contains(event.target)) { if (event.type === 'click') event.preventDefault(); return; }
    if (heldName(event.target) && event.key !== 'Tab') event.preventDefault();
  }

  function putBack(event) {
    var name = busy && heldName(event.target);
    if (name) write(fields[name], held[name]);
  }

  restore();
  form.noValidate = true;
  /* Shopify's captcha script listens for this submit too and can send the form itself, so this runs first. */
  document.addEventListener('submit', onSubmit, true);
  ['click', 'mousedown', 'keydown'].forEach(function (type) { form.addEventListener(type, hold, true); });
  form.addEventListener('change', putBack, true);
  form.addEventListener('input', function () { C.repaint(TYPE, fields); });
  form.addEventListener('change', function () { C.repaint(TYPE, fields); });
  window.addEventListener('pageshow', function (event) { if (event.persisted) setBusy(false); });
})(window.Vantor = window.Vantor || {});
